import { z } from "zod";
export const OperacionSyncEnum = z.enum(["INSERT", "UPDATE", "DELETE"]);
export const EstadoSyncOutboxEnum = z.enum(["PENDIENTE", "ENVIADO", "ERROR"]);
export const ItemOutboxSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    entidad: z.string(),
    entidadId: z.string(),
    operacion: OperacionSyncEnum,
    payloadJson: z.string(),
    creadoEn: z.string(),
});
export const SyncPushPayloadSchema = z.object({
    sucursalId: z.string(),
    timestamp: z.number(),
    eventos: z.array(ItemOutboxSchema),
});
export const SyncPushResponseSchema = z.object({
    exito: z.boolean(),
    procesados: z.number(),
    idsProcesados: z.array(z.string()),
    errores: z.array(z.object({ id: z.string(), error: z.string() })).optional(),
});
export const SyncEstadoRespuestaSchema = z.object({
    appNode: z.enum(["local", "nube"]),
    pendientesOutbox: z.number(),
    ultimoEnviadoEn: z.string().nullable(),
    enLinea: z.boolean(),
    latenciaMs: z.number().nullable(),
});
//# sourceMappingURL=sync.schema.js.map